<span class="button-text-wrapper">
  <ng-content></ng-content>
</span>
